import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';



@Component({
    selector: 'app-product-services',
    templateUrl: './product-services.component.html',
    styleUrls: ['./product-services.component.css'],
    standalone: false
})
export class ProductServicesComponent implements OnInit {

 
  ngOnInit() {
    this.loadFonts();
  }
 
  private loadFonts() {
    var self = this;
 
    if (!document.getElementById('ps-font-preconnect')) {
      var preconnect = document.createElement('link');
      preconnect.id = 'ps-font-preconnect';
      preconnect.rel = 'preconnect';
      preconnect.href = 'https://fonts.googleapis.com';
      document.head.appendChild(preconnect);
    }
 
    if (!document.getElementById('ps-google-fonts')) {
      var fontLink = document.createElement('link');
      fontLink.id = 'ps-google-fonts';
      fontLink.rel = 'stylesheet';
      fontLink.href = 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;600;700&family=Nunito:wght@400;600;700;800&display=swap';
      fontLink.onerror = function () {
        console.warn('Sehyog fonts failed to load from Google Fonts CDN.');
      };
      document.head.appendChild(fontLink);
    }
  }
 
  openWhatsApp() {
    window.open('https://wa.me/447464772331', '_blank');
  }

   bookFreeDemo() {
    window.open('https://go.sehyog.co.uk/FreeDemoForm', '_blank');
  } 
}
